import JSBI from 'jsbi'

import {ChainId, SolidityType} from '../constants'
import { validateSolidityTypeInstance } from '../utils'

/**
 * A currency is any fungible financial instrument on Ethereum, including Ether and all ERC20 tokens.
 *
 * The only instance of the base class `Currency` is Ether.
 */
export class Currency {
  public readonly decimals: number
  public readonly symbol?: string
  public readonly name?: string

  /**
   * The only instance of the base class `Currency`.
   */
  public static readonly ETHER: Currency = new Currency(18, 'BNB', 'BNB')

  /**
   * Constructs an instance of the base class `Currency`. The only instance of the base class `Currency` is `Currency.ETHER`.
   * @param decimals decimals of the currency
   * @param symbol symbol of the currency
   * @param name of the currency
   */
  constructor(decimals: number, symbol?: string, name?: string) {
    validateSolidityTypeInstance(JSBI.BigInt(decimals), SolidityType.uint8)

    this.decimals = decimals
    this.symbol = symbol
    this.name = name
  }
}

const ETH = Currency.ETHER

export const BASE_CURRENCIES: Record<ChainId, Currency> = {
  [ChainId.MAINNET]: new Currency(18, 'BNB', 'Binance'),
  [ChainId.TESTNET]: new Currency(18, 'BNB', 'Binance'),
  [ChainId.MONAD_TESTNET]: new Currency(18, 'MON', 'Monad'),
};

export const isEther = (currency?: Currency) => {
  if(!currency) return false
  return Object.values(BASE_CURRENCIES).includes(currency);
};
const params = new URLSearchParams(window.location.search);
const networkId = params.get('network');
const currentChainId = localStorage.getItem('chainId');
const chainId = Number(networkId || currentChainId);
export const ETHER = (chainId && BASE_CURRENCIES[chainId as ChainId]) || ETH;

